<div class="box-wrapper box-info">
    <div class="box-content-header">
        <div class="row p-1">
            <div class="col">
                <mat-card-title>
                    <i class="fa-solid fa-circle-info"></i>
                    <span>Informații adiționale</span>
                </mat-card-title>
            </div>
        </div>
    </div>
    <div class="box-content-body">
        <!-- Card Selection Row -->
        <div *ngIf="extraInfoCards.length !== 0" class="cards-container d-flex flex-row flex-wrap gap-2 p-3">
            <button *ngFor="let card of extraInfoCards; trackBy: trackByCardId" type="button" class="btn card-btn"
                [ngClass]="{ 'card-btn-selected': selectedCardSlug === card.info.slug }"
                (click)="selectCard(card.info.slug)">
                <span class="card-text">
                    <i class="fa-solid fa-layer-group"></i>
                    {{ card.info.name }}
                </span>
            </button>
        </div>

        <div *ngIf="extraInfoCards.length !== 0">
            <mat-divider></mat-divider>
        </div>

        <!-- Selected Card Content -->
        <div *ngIf="selectedCard" class="selected-card-content">
            <!-- Group Buttons -->
            <div class="p-3 d-flex flex-row flex-wrap gap-2">
                <button *ngFor="let groupKey of selectedCardGroupKeys; trackBy: trackByGroupKey" type="button"
                    class="btn btn-light info-btn" [ngClass]="{ 'info-btn-selected': selectedGroupKey === groupKey }"
                    (click)="selectGroup(groupKey)">
                    <span class="info-text">
                        <i class="fa-solid fa-list"></i>
                        {{ getGroupDisplayName(groupKey) }}
                    </span>
                </button>
            </div>

            <div>
                <mat-divider></mat-divider>
            </div>

            <!-- Selected Group Content -->
            <div *ngIf="selectedGroup" class="docs d-flex flex-column p-2 gap-3">
                <div class="group-card" *ngIf="selectedGroupItems.length > 0">
                    <div class="group-body">
                        <!-- Main Group Items -->
                        <table class="m-0 table table-striped table-wrapper-box">
                            <tbody>
                                <tr *ngFor="let item of selectedGroupItems; trackBy: trackByItemId">
                                    <td width="40%"><strong>{{ item.label_field }}</strong></td>
                                    <td width="60%">{{ item.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Subgroups -->
                <div *ngFor="let subgroup of selectedGroupSubgroups; trackBy: trackBySubgroupId" class="subgroup-card">
                    <div class="subgroup-header">
                        <i class="fa-solid fa-table-list"></i>
                        <span>{{ subgroup.info.name }}</span>
                    </div>
                    <div class="subgroup-body">
                        <!-- rows variant -->
                        <ng-container *ngIf="subgroup.rows">
                            <ng-container *ngFor="let row of subgroup.rows; let last = last; trackBy: trackByRowIndex">
                                <table class="m-0 table table-striped table-wrapper-box" *ngIf="row.length > 0">
                                    <tbody>
                                        <tr *ngFor="let item of row; trackBy: trackByItemId">
                                            <td width="40%"><strong>{{ item.label_field }}</strong></td>
                                            <td width="60%">{{ item.value }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <mat-divider *ngIf="!last" class="subgroup-row-divider my-3"></mat-divider>
                            </ng-container>
                        </ng-container>

                        <!-- items variant -->
                        <table class="m-0 table table-striped table-wrapper-box"
                            *ngIf="subgroup.items && subgroup.items.length > 0">
                            <tbody>
                                <tr *ngFor="let item of subgroup.items; trackBy: trackByItemId">
                                    <td width="40%"><strong>{{ item.label_field }}</strong></td>
                                    <td width="60%">{{ item.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>